import { IAppVersion } from './app-version.interface';
import { IVersionUpdate } from './IAppUpdate.interface';
import { IAcquirer } from './vf-market-app.interface';

export interface IApp extends IAppVersion {
  appId?: string;
  isDefaultApp?: boolean;
  acquirerIsDefault?: boolean;
  testingInstructions?: string;
  appmarketAppId?: string;
  price?: number;
  acquirers?: IAcquirer[];
  acquirerApp?: {
    isFeatured?: boolean;
    isPilot?: boolean;
    isPublic?: boolean;
    isDefault?: boolean;
  };
  versionsToUpdate?: IVersionUpdate[];
  appDeviceAssignmentId?: string;
  isFeatured?: boolean;
  isPublic?: boolean;
  isPilot?: boolean;
  isDefault?: boolean;
  isAvailableForUpgrade?: boolean;
  appcatalogIsDefaultApp?: boolean;
  merchantEntityUid?: string;
  defaultApp?: boolean;
}
